import React, { useEffect, useState } from 'react';
import { DialogTitle, DialogContent, DialogActions } from '../../Dialog/Dialog';
import {
    Dialog,
    makeStyles,
    InputAdornment,
    FormHelperText,
    Grid,
    Button
} from "@material-ui/core";
import { connect } from 'react-redux';
import { addNewDriver, getDieselCardDriverList, updateDieselCardPin, updateVehicle3 } from "../../../../store/actions/vehicleActionCreator";
import { Form } from 'react-final-form';
import { TextField, Autocomplete } from 'mui-rff';
import * as logger from "../../../../logger";
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { AddPersonIcon } from '../../../../components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import AddEditNewDriver from "../AddEditNewDriver";
import { useHistory, useLocation } from "react-router-dom";
import { checkNumberOnly } from '../../../../utils/utils';


const useStyles = makeStyles((theme) => ({

    brV1: {
        borderRadius: 8
    },
    dialogContent: {
        backgroundColor: '#f6f6f8 '
    },
    saveCta: {
        backgroundColor: '#09101e',
        borderRadius: '4px',
        color: 'white',
        textTransform: 'none',
        fontSize: 14,
        boxShadow: 'none !important',
        "&:hover": {
            backgroundColor: '#09101e'
        }
    },
    disableCta: {
        backgroundColor: '#dadada',
        fontSize: 14,
        color: '#5e636c',
        borderRadius: 4,
        textTransform: 'none',
        boxShadow: 'none !important',
        "&: hover": {
            backgroundColor: '#dadada'
        }
    },
    textFieldV1: {
        "& .MuiOutlinedInput-root": {
            backgroundColor: 'white !important'
        }
    },
    titleV1: {
        color: 'rgba(11, 19, 35, 0.75)',
        marginBottom: 4,
        fontWeight: 600
    },
    mt24: {
        marginTop: 24
    },
    mt16: {
        marginTop: 16
    },
    listBoxAutoCompelete: {
        margin: 0,
        padding: 0,
        maxHeight: '30vh'
    },
    listBoxOption: {
        padding: 0,
        borderBottom: '1px solid #eaedf3',
        "&:first-child": {
        },
        "&:last-child": {
        }
    },
    titleBullet: {
        borderRadius: "50%",
        backgroundColor: "lightgrey",
        fontSize: 8,
        color: "lightgrey",
        margin: "0px 6px",
        marginTop: -2
    },
    driverAddListItem: {
        padding: '12px 15px',
        margin: 0,
        backgroundColor: '#e3e8fd',
        color: '#5170f0',
        fontWeight: 300,
        minHeight: 46,
        width: '100%',
        maxHeight: 46
    },
    addPersonIcon: {
        color: '#5170f0',
        marginRight: 10
    },
    cherveRightIcon: {
        marginLeft: 10,
        float: 'right',
        color: '#5170f0'
    },
    formControlPropsRoot: {
        marginTop: '4px !important',
        marginBottom: '0px !important'
    },
    autoCompleteRoot: {
        "& .MuiFormControl-marginNormal": {
            marginTop: '4px !important',
            marginBottom: '0px !important'
        }
    },
    inputRootV1: {
        backgroundColor: 'white !important'
    },
    driverListItem: {
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 20,
        paddingRight: 20
    },
    divTitle: {
        color: 'rgba(11, 19, 35, 0.5)',
        fontSize: 12,
        textAlign: 'left',
        fontWeight: 600
    },
    divContainer: {
        backgroundColor: '#ededed',
        border: '1px solid #dcdcdc',
        borderRadius: 8,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 16,
        paddingBottom: 16
    },
    truckNumberContainer: {
        display: 'flex',
        fontWeight: 'bold',
        fontSize: 16,
        marginTop: 4
    },
    mlV1: {
        marginLeft: 4
    },

}));

const filter = createFilterOptions({
    limit: 30
});

function decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}

const EditDieselCardDialog = ({ open, vehicle, dispatchGetDieselCardDriverList, dispatchUpdateVehicle, dispatchUpdateDieselCardPin, onClose }) => {

    let location = useLocation();
    let submit;
    const dieselCardDetails = vehicle && vehicle.singleDieselCardInfo ? vehicle.singleDieselCardInfo : {}

    let pathName = location && location.pathname ? location.pathname.split("/") : [];
    let brokerIdValue = pathName && pathName[pathName.length - 1] ? pathName[pathName.length - 1] : "";

    const classes = useStyles();

    const [dialogOpen, setDialogOpen] = useState(open);
    const [driverIdValue, setDriverIdValue] = useState(dieselCardDetails && dieselCardDetails.driverId ? dieselCardDetails.driverId : null);
    const [pinValue, setPinValue] = useState(dieselCardDetails && dieselCardDetails.pin ? dieselCardDetails.pin : null);
    const [addDriverOpen, toggleAddDriverOpen] = useState(false);
    const [newDriverName, setNewDriverName] = useState("");
    const [confirmDisabled, setConfirmDisabled] = useState(false);
    const [driverFlow, setDriverFlow] = useState(null);
    const [verifyDriver, setVerifyDriver] = useState(null);

    useEffect(() => {

        handleRecallDriversList();

    }, [])

    useEffect(() => {

        if (driverIdValue) {
            const driverDetails = (vehicle.fuelCardDriverList).find((driverInfo) => driverInfo.id == driverIdValue)

            if (driverDetails && !driverDetails.contactNumber) {
                toggleAddDriverOpen(true);
                setDriverFlow("verify")
                setVerifyDriver(driverDetails);
            }

        }

    }, [driverIdValue, vehicle.fuelCardDriverList]);

    const initialValues = {
        driver: driverIdValue,
        pin: pinValue
    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mt24}>
                            <div className={classes.titleV1}>Driver*</div>
                            {vehicle && vehicle.fuelCardDriverList && vehicle.fuelCardDriverList.length > 0 &&
                                <Autocomplete
                                    classes={{
                                        listbox: classes.listBoxAutoCompelete,
                                        option: classes.listBoxOption,
                                        root: classes.autoCompleteRoot,
                                        inputRoot: classes.inputRootV1
                                    }}
                                    id="select-driver-list"
                                    name="driver"
                                    size="small"
                                    // getOptionSelected={(option, value) => option.id === value.id}
                                    // open={true}
                                    onChange={(event, newValue) => {
                                        if (typeof newValue === 'string') {
                                            // timeout to avoid instant validation of the dialog's form.
                                            setTimeout(() => {
                                                setDriverIdValue(null);
                                                toggleAddDriverOpen(true);
                                            });
                                        } else if (newValue && newValue.inputValue) {
                                            setDriverIdValue(null);
                                            toggleAddDriverOpen(true);
                                        } else if (newValue && newValue.inputValue === '') {
                                            setDriverIdValue(null);
                                            toggleAddDriverOpen(true);
                                        } else {
                                            setDriverIdValue(newValue && newValue.id ? newValue.id : null);
                                        }
                                        setDriverFlow("add");
                                    }}
                                    required={true}
                                    autoHighlight
                                    options={vehicle && vehicle.fuelCardDriverList ? vehicle.fuelCardDriverList : []}
                                    selectOnFocus
                                    clearOnBlur
                                    getOptionValue={option => option.id}
                                    getOptionLabel={(option) => {
                                        // e.g value selected with enter, right from the input
                                        if (typeof option === 'string') {
                                            return '';
                                        }
                                        if (option.inputValue || !option.id) {
                                            return '';
                                        }
                                        // return option && option.name ? option.name : ''
                                        if (option && option.contactNumber) {
                                            return `${option.name}  ` + decodeHtml("&#9679;") + `  ${option.contactNumber}`
                                        } else {
                                            return option && option.name ? option.name : ''
                                        }
                                    }}
                                    disableCloseOnSelect={false}
                                    filterOptions={(options, params) => {
                                        const filtered = filter(options, params);
                                        if (params.inputValue && (params.inputValue.trim()).length > 1) {
                                            // setNewDriverName(params.inputValue)
                                            setVerifyDriver(params.inputValue)
                                        }
                                        filtered.unshift({
                                            inputValue: params.inputValue,
                                            name: params.inputValue && params.inputValue.length > 1 ? `Add Details for <span style="color: black !important">"${params.inputValue}"</span>` : `Add New Driver`,
                                        });
                                        return filtered;
                                    }}
                                    filterSelectedOptions
                                    renderOption={(option, { selected, inputValue }) => {
                                        let matchesName, matchesNumber;
                                        let partsName, partsNumber;
                                        matchesName = match(option.name, inputValue);
                                        partsName = parse(option.name, matchesName);
                                        matchesNumber = match(option.contactNumber, inputValue);
                                        partsNumber = parse(option.contactNumber, matchesNumber);

                                        if (option && option.id) {
                                            return (
                                                <div className={classes.driverListItem}>
                                                    {partsName.map((part, index) => {
                                                        return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#5170f0' : '#0b1323' }}>
                                                            {part.text}
                                                        </span>
                                                        )
                                                    })}
                                                    <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                                                    {option.contactNumber ?
                                                        (<>
                                                            {partsNumber.map((part, index) => {
                                                                return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#5170f0' : '#0b1323' }}>
                                                                    {part.text}
                                                                </span>
                                                                )
                                                            })}
                                                        </>)
                                                        :
                                                        (
                                                            <span>--</span>
                                                        )
                                                    }
                                                </div>
                                            );

                                        } else {
                                            return (
                                                <div className={classes.driverAddListItem}>
                                                    <AddPersonIcon className={classes.addPersonIcon} />
                                                    <span dangerouslySetInnerHTML={{ __html: option.name }}></span>
                                                    <ChevronRightIcon className={classes.cherveRightIcon} />
                                                </div>
                                            );
                                        }

                                    }}

                                    textFieldProps={
                                        {
                                            placeholder: "Select a Driver",
                                            variant: "outlined",
                                            margin: 'normal',
                                        }
                                    }
                                    multiple={false}
                                />
                            }
                        </div>
                    </>
                )

            },
            {
                size: 12,
                visible: dieselCardDetails && dieselCardDetails.pin ? true : false,
                field: (
                    <>
                        <div className={classes.mt16}>
                            <div className={classes.titleV1}>PIN*</div>
                            <TextField
                                placeholder='Enter Pin'
                                name="pin"
                                variant="outlined"
                                size="small"
                                onChange={(e) => setPinValue(e.target.value)}
                                required={true}
                                fieldProps={{
                                    parse: value => value && (value.trim()).length == 0 ? value.trim() : value
                                }}
                                classes={{ root: classes.textFieldV1 }}
                            />
                        </div>
                    </>
                )
            }
        ]
    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const onSubmit = values => {

        if (!confirmDisabled) {

            const initialDriverId = dieselCardDetails && dieselCardDetails.driverId ? dieselCardDetails.driverId : "";
            const initialPin = dieselCardDetails && dieselCardDetails.pin ? dieselCardDetails.pin : "";
            const vehicleIdValue = dieselCardDetails && dieselCardDetails.vehicleId ? dieselCardDetails.vehicleId : ""

            // **************************** Using if else to avoid unnecessary API calls ****************************
            if ((values.driver != initialDriverId) && (values.pin != initialPin)) {

                const updateVehicleData = {
                    driverId: driverIdValue
                }

                const pinRequest = {
                    vehicleId: vehicleIdValue,
                    pin: values.pin,
                    brokerId: brokerIdValue // Backend change required
                }

                dispatchUpdateVehicle(vehicleIdValue, updateVehicleData,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log("Driver Details Dialog Dweb", "Updated Vehicle successfully");
                            dispatchUpdateDieselCardPin(pinRequest,
                                (data) => {
                                    if (data && data.status && data.status.code == 200) {
                                        logger.log("Edit Diesel Card Dialog Dweb", "Diesel card pin updated successfully");
                                        handleClose()
                                    }
                                },
                                () => {
                                    logger.log("Edit Diesel Card Dialog Dweb", "Diesel card pin updated failed");
                                }
                            )
                        }
                    },
                    () => {
                        logger.log("Driver Details Dialog Dweb", "Update vehicle failed");
                    }
                )

            } else if ((values.driver != initialDriverId) || (initialPin && values.pin != initialPin)) {

                if (values.driver != initialDriverId) {

                    const updateVehicleData = {
                        driverId: driverIdValue
                    }

                    dispatchUpdateVehicle(vehicleIdValue, updateVehicleData,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("Driver Details Dialog Dweb", "Updated Vehicle successfully");
                                handleClose()
                            }
                        },
                        () => {
                            logger.log("Driver Details Dialog Dweb", "Update vehicle failed");
                        }
                    )

                }

                if (initialPin && values.pin != initialPin) {

                    const pinRequest = {
                        vehicleId: vehicleIdValue,
                        pin: values.pin,
                        brokerId: brokerIdValue
                    }

                    dispatchUpdateDieselCardPin(pinRequest,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("Edit Diesel Card Dialog Dweb", "Diesel card pin updated successfully");
                                handleClose()
                            }
                        },
                        () => {
                            logger.log("Edit Diesel Card Dialog Dweb", "Diesel card pin updated failed");
                        }
                    )

                }
            } else {
                handleClose();
            }

        }

    }

    const validate = values => {
        var errors = {}

        if (!values.driver) {
            errors.driver = 'Please Select a Driver';
        }

        if (dieselCardDetails && dieselCardDetails.pin) {
            if (!values.pin || !checkNumberOnly(values.pin) || (values && values.pin ? (values.pin).length != 4 : true)) {
                errors.pin = 'Please enter valid four digit PIN';
            }
        }

        if ((Object.keys(errors)).length > 0) {
            setConfirmDisabled(true);
        } else {
            setConfirmDisabled(false);
        }

        return errors
    }

    const handleRecallDriversList = () => {

        dispatchGetDieselCardDriverList(
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Edit Deisel Card Dialog", "Get Diesel Card Drivers List Successfull");
                }
            },
            () => {
                logger.log("Edit Deisel Card Dialog", "Get Diesel Card Drivers List Failed");
            }
        )

    }

    const handleAddDriverClose = () => {
        toggleAddDriverOpen(false)
        setNewDriverName("");
        setVerifyDriver(null);
        setDriverFlow(null);
    }

    const handleDriverSave = (response) => {
        vehicle.fuelCardDriverList = [];
        handleRecallDriversList();
        toggleAddDriverOpen(false)
        setDriverIdValue(response && response.id ? response.id : null);
        setNewDriverName("");
        setVerifyDriver(null);
        setDriverFlow(null);
    }

    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='xs'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-party-dialog-title" open={dialogOpen}
                classes={{ paperScrollPaper: classes.brV1 }}
            >
                <DialogTitle id="edit-diesel-card-detail-title" onClose={handleClose}>
                    Edit Diesel Card
                </DialogTitle>

                <DialogContent dividers className={classes.dialogContent}>

                    <div className={classes.divContainer}>
                        <div className={classes.divTitle}>Truck No.</div>
                        <div className={classes.truckNumberContainer}>
                            {
                                dieselCardDetails && dieselCardDetails.vehicleNumArrayValue && dieselCardDetails.vehicleNumArrayValue.map((truckNumber, index) => (
                                    <div className={index != 0 ? classes.mlV1 : ""}>{truckNumber}</div>
                                ))
                            }

                        </div>
                    </div>

                    <Form
                        onSubmit={onSubmit}
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />

                </DialogContent>

                <DialogActions>
                    <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
                        Close
                    </Button>
                    <Button className={confirmDisabled ? classes.disableCta : classes.saveCta} type="submit" variant="contained"
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {/* *********************************** Add Driver Dialog *********************************** */}
            {addDriverOpen && <AddEditNewDriver open={addDriverOpen} driverFlowValue={driverFlow} verifyDriverInfo={verifyDriver} onClose={handleAddDriverClose} onConfirm={handleDriverSave} />}
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchGetDieselCardDriverList: (onSuccess, onError) => {
        dispatch(getDieselCardDriverList(onSuccess, onError))
    },
    dispatchUpdateVehicle: (vehicleId, data, onSuccess, onError) => {
        dispatch(updateVehicle3(vehicleId, data, onSuccess, onError))
    },
    dispatchUpdateDieselCardPin: (data, onSuccess, onError) => {
        dispatch(updateDieselCardPin(data, onSuccess, onError))
    }

})

export default connect(mapStateToProps, mapDispatchToProps)(EditDieselCardDialog);
